import { render, staticRenderFns } from "./SwitchBrandPopup.vue?vue&type=template&id=684c4618&scoped=true&"
import script from "./SwitchBrandPopup.vue?vue&type=script&lang=ts&"
export * from "./SwitchBrandPopup.vue?vue&type=script&lang=ts&"
import style0 from "./SwitchBrandPopup.vue?vue&type=style&index=0&id=684c4618&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "684c4618",
  null
  
)

export default component.exports